// extracted by mini-css-extract-plugin
export default {"chip":"styles_chip__KYfKh","secondaryWhite":"styles_secondaryWhite__7kyIs","active":"styles_active__pnUIS","big":"styles_big__fUctI","isButton":"styles_isButton__7hi5l"};